import { ApiFactoryClassType } from './factory';
import { FormValues } from '../components/form/types';
import { PaginationType } from './types';

const thriftshop = (factory: ApiFactoryClassType) => ({
    createListing: async (listingObj: FormValues): Promise<any> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL('/api/listing/create', factory.getApiHost()),
                {
                    method: 'POST',
                    body: JSON.stringify(listingObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    editListing: async (listingObj: FormValues, id: string): Promise<any> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/listing/${id}`, factory.getApiHost()),
                {
                    method: 'PUT',
                    body: JSON.stringify(listingObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    listingsList: async (
        limit: number = 15,
        offset: number = 0,
        sort?: string,
        order?: string
    ): Promise<PaginationType | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/listing/list?limit=${limit}&offset=${offset}${sort && order ? `&sort=${sort}&order=${order}` : ``}`, factory.getApiHost()),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    templateList: async (
        limit: number = 15,
        offset: number = 0,
        sort?: string,
        order?: string
    ): Promise<PaginationType | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/template/list?limit=${limit}&offset=${offset}${sort && order ? `&sort=${sort}&order=${order}` : ``}`, factory.getApiHost()),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    createTemplate: async (listingObj: FormValues): Promise<any> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL('/api/template/create', factory.getApiHost()),
                {
                    method: 'POST',
                    body: JSON.stringify(listingObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    editTemplate: async (listingObj: FormValues, id: string): Promise<any> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/template/${id}`, factory.getApiHost()),
                {
                    method: 'PUT',
                    body: JSON.stringify(listingObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
});

export default thriftshop;
